import HttpService from "./htttp.service";

class AuthService {

  login = async (payload) => {
    const loginEndpoint = 'oauth/token';
    payload.grant_type = 'password'
    return await HttpService.postLogin(loginEndpoint, payload);
  };

  register = async (credentials) => {
    const registerEndpoint = 'register';
    return await HttpService.postRegister(registerEndpoint, credentials);
  };

  activateAccount = async (userId, activationId) => {
    const activateEndpoint = `users/${userId}/activate/${activationId}`;
    return await HttpService.putPublic(activateEndpoint, {});
  };

  resetPasswordRequest = async (userEmail) => {
    const resetPasswordEndpoint = `users/${userEmail}/password/reset`;
    return await HttpService.postPublic(resetPasswordEndpoint, {});
  };

  resetPasswordWithOperationId = async (resetId, newPassword) => {
    const resetPasswordEndpoint = `users/password?operationId=${resetId}`;
    return await HttpService.putPublic(resetPasswordEndpoint, { password: newPassword });
  };

  async logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userId");
    return true;
  }

  getProfile = async(userEmail) => {
    const profileEndpoint = `users/${userEmail}`
    return await HttpService.get(profileEndpoint);
  }
}

export default new AuthService();